import React from 'react'
import { useEffect } from 'react'
import Cookies from 'universal-cookie';
import { COOKIE_SETTINGS } from '../../config/cookiesSettings';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LoaderComponent } from '../../components/utils/LoaderComponent';

const OktaSuccess = () => {
    const history = useHistory();
    useEffect(() => {
        let searchParams = new URLSearchParams(window.location.search);
        const auth_token = searchParams.get("token");
        const cookies = new Cookies();
        cookies.set('api_key', auth_token, {path: '/', maxAge: COOKIE_SETTINGS['AUTH_DURATION']});
        window.history.replaceState(null, "", "/okta_success");
        window.location.href = "/switch_acc";
    }, [])
    return (
        <LoaderComponent isLoading={true} type="FULL_PAGE" loaderStyle={{ width: 64}}/>
    )
}

export default OktaSuccess